import React from "react";
import MatchTile from "../../Match/MatchTile";
import RoundedRectangle from "../../RoundedRectangle";
import { MatchSmallElement } from "../../../../config/types";

const TeamLastMatch: React.FC<{
  match?: MatchSmallElement | null;
  isMainLeagueOverride?: boolean;
}> = ({ match, isMainLeagueOverride }) => (
  <RoundedRectangle
    className="team-lastmatch-panel w-full bg-bg-secondary dark:bg-bg-secondary-dark border border-light-gray dark:border-light-gray-dark"
    hasBorder
    hasTitle
    titleType="upLeft"
    titleKey="lastMatch"
  >
    <div className="tablet-panel-body relative mt-4">
      {match ? (
        <div className="relative shrink-0">
          <MatchTile
            match={match}
            banner="date-league"
            isMainLeagueOverride={isMainLeagueOverride}
          />
        </div>
      ) : (
        <div className="px-4 py-2">
            <span className="font-medium text-center pr-2 text-font dark:text-font-dark text-xs">
            -
          </span>
        </div>
      )}
    </div>
  </RoundedRectangle>
);

export default TeamLastMatch;
